import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./supportDetails.html";
import * as kagekiri from 'kagekiri';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
const FOCUSABLE_ELEMENTS = ['wds-button'];
class SupportDetails extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.displayTermsAndConditions = false;
  }
  i18nCallback(i18n) {
    this.labels = i18n.support;
    this.termsAndConditionsModalLabels = i18n.modals.termsAndConditions;
    this.sharedLabels = i18n.shared;
  }
  get mailTo() {
    if (this.supportInfo?.supportEmailAddress) {
      return `mailTo:${this.supportInfo.supportEmailAddress}`;
    }
    return '';
  }
  get focusableElements() {
    return FOCUSABLE_ELEMENTS;
  }
  get logo() {
    // @ts-expect-error * Automated Type Error Fix
    if (this.listing?.publisher && this.listing?.publisher['publisher/plugins/PublisherLogo']) {
      // @ts-expect-error * Automated Type Error Fix
      return generateMediaUrl(this.listing.publisher['publisher/plugins/PublisherLogo'].Logo);
    }
    return '';
  }
  get termsAndConditions() {
    const listingExtension = selectExtensionListing(this.listing);
    return listingExtension.licenseAgreement ?? '';
  }
  get supportInfo() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing && this.listing['listing/plugins/SupportInformation'];
  }
  get supportDetails() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing?.['listing/plugins/SupportInformation']?.supportDetails ?? '';
  }
  get supportPhoneNumber() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing?.['listing/plugins/SupportInformation']?.supportPhoneNumber ?? '';
  }
  get supportKnowledgeBaseURL() {
    // @ts-expect-error * Automated Type Error Fix
    return this.listing?.['listing/plugins/SupportInformation']?.supportKnowledgeBaseURL ?? '';
  }
  get publisherName() {
    return this.listing?.publisher?.name ?? '';
  }
  get publisherLocation() {
    return this.listing?.publisher?.hQLocation ?? '';
  }
  get termsAndConditionsLinkRef() {
    return kagekiri.querySelector('.terms-and-conditions-link');
  }
  get logoAlt() {
    return this.publisherName ? i18nStore.getState().i18n.shared.logoAlt({
      LOGO_NAME: this.publisherName
    }) : this.sharedLabels.deafultLogoAlt;
  }
  openTermsAndConditions(event) {
    event.preventDefault();
    this.displayTermsAndConditions = true;
  }
  closeTermsAndConditions() {
    this.displayTermsAndConditions = false;
    this.termsAndConditionsLinkRef.focus();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SupportDetails, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["displayTermsAndConditions"]
});
const __lwc_component_class_internal = _registerComponent(SupportDetails, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;